// Every change to a book says so (Shelves, Oct 28), so a shelf under the book's side panel, or a
// shelf whose card made the change, can read its books again.

export const BOOKS_CHANGED = 'rl:books-changed';

export function booksChanged(): void {
  try {
    window.dispatchEvent(new Event(BOOKS_CHANGED));
  } catch {
    /* no window (logic tests) */
  }
}
